import { WidgetType } from 'types/widget.types';

import { DEFAULT_LINE_ICON_DATA } from './LineIconWidget.config';
import { LineIconType, LineIconWidgetData } from './LineIconWidget.types';
import { VERSION } from './LineIconWidget.upgrade';

/**
 * Returns style of line icon svg based on mirror property
 *
 * @param mirror
 * @returns
 */
export const generateLineStyle = (mirror: boolean) => {
  const style = { position: 'absolute' as 'absolute' };

  const scaleX = mirror ? -1 : 1;

  if (mirror) {
    return {
      ...style,
      transform: `scaleX(${scaleX})`,
      transformOrigin: 'center',
    };
  }
  return style;
};

export const generateDefaultData = (type: LineIconType, options?: Partial<LineIconWidgetData>) => {
  const defaultData = DEFAULT_LINE_ICON_DATA[type];
  return {
    widgetType: WidgetType.LineIcon,
    widgetData: {
      version: VERSION,
      rotateDeg: 0,
      topPx: 0,
      leftPx: 0,
      isDecorative: true,
      altText: '',
      mirror: {
        isHorizontal: false,
      },
      type,
      ...defaultData,
      ...options,
    },
  };
};
